export default {"src":"/_next/static/media/flag_switch_id.17346771.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};